import { render, staticRenderFns } from "./ordersModal.vue?vue&type=template&id=71952189&scoped=true&"
import script from "./ordersModal.vue?vue&type=script&lang=js&"
export * from "./ordersModal.vue?vue&type=script&lang=js&"
import style0 from "./ordersModal.vue?vue&type=style&index=0&id=71952189&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71952189",
  null
  
)

export default component.exports